import {
  consentStatuses,
  localStorageKey,
  SocialFundApi,
  SocialFundRoutes,
} from '~/app/features/social-fund/utils/consts';
import { WEB_ROUTES } from '~/utils/webConfig';

export class LoadingService {
  #intervalTimeoutMS = 5000;

  #interval;

  statuses = {
    [consentStatuses.initiated]: SocialFundRoutes.social_fund,
    [consentStatuses.error]: SocialFundRoutes.social_fund,
    [consentStatuses.valid]: WEB_ROUTES.REGISTRATION_STEP_6,
    [consentStatuses.failed]: WEB_ROUTES.REGISTRATION_STEP_6,
  };

  constructor(ctx) {
    this.ctx = ctx;
  }

  checkStatus() {
    this.#interval = setInterval(async () => {
      const { response } = await this.ctx.$api.dispatch(SocialFundApi.check_social_fund_status);
      const status = response && response.data && response.data.status;
      this.redirectByStatus(status);
    }, this.#intervalTimeoutMS);
  }

  stopCheckStatus() {
    if (this.#interval) {
      clearInterval(this.#interval);
    }
  }

  /**
   * @param {string} status
   * @returns {void}
   */
  redirectByStatus(status) {
    if ([consentStatuses.valid, consentStatuses.failed].includes(status)) {
      localStorage.removeItem(localStorageKey);
    }

    if (![consentStatuses.pending, consentStatuses.waitingForVerification].includes(status)) {
      this.ctx.redirect(this.ctx.app.localePath(this.statuses[status]));
      this.stopCheckStatus();
    }
  }
}
